import React from 'react'
import Profile from './Profile'

const index = () => <Profile/> 


export default index